import styled from 'styled-components';
import { List, token, VerticalNav } from '@bynder/design-system';
import { SIDEBAR_WIDTH } from '../../DesignCreateModal.styled';

export const VerticalNavBackAction = styled(VerticalNav.Item)`
    margin-bottom: ${token.spacing6} !important;
`;

// Align the list rows with the back button: VerticalNav insets its items by
// spacing5 (container margin) + spacing4 (item padding), while List.Item pulls
// its own background out by -spacing4. Matching that here lines both the row
// backgrounds and their content up with the back button above.
export const StyledList = styled(List)`
    && {
        padding: ${token.spacing3} calc(${token.spacing5} + ${token.spacing4});
    }
`;

// TODO: remove it once DS modal sidebar will have a property hasNoBorder
export const ModalSidebar = styled.div`
    grid-area: sidebar;
`;

export const StyledSidebar = styled.aside`
    overflow-y: auto;
    box-sizing: border-box;
    width: ${SIDEBAR_WIDTH};
    height: 100%;
    padding: ${token.spacing5} 0;
`;
